import { GENDER } from './appConstants';
import { generateYearOptionsFrom } from 'utils/form';

export const GENDER_OPTIONS = [GENDER.MALE, GENDER.FEMALE, GENDER.OTHER];
export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'];
export const MARITIAL_STATUS_OPTIONS = ['Married', 'Single'];
export const EMPLOYEE_AREA = ['QA', 'ASE QA', 'DEV', 'Finance'];

export const YEAR_OPTIONS = generateYearOptionsFrom(new Date().getFullYear());
